import { render } from "./SetReview.vue?vue&type=template&id=d181082e"
import script from "./SetReview.vue?vue&type=script&lang=js"
export * from "./SetReview.vue?vue&type=script&lang=js"

import "./SetReview.vue?vue&type=style&index=0&id=d181082e&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__